<ng-container *nzStringTemplateOutlet="nzLabel">{{ nzLabel }}</ng-container>
